import { render, staticRenderFns } from "./boxnum.vue?vue&type=template&id=ec602dc0&scoped=true"
import script from "./boxnum.vue?vue&type=script&lang=js"
export * from "./boxnum.vue?vue&type=script&lang=js"
import style0 from "./boxnum.vue?vue&type=style&index=0&id=ec602dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec602dc0",
  null
  
)

export default component.exports